import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export interface Shipment {
  id: string;
  tracking_number: string;
  status: string;
  origin: string;
  destination: string;
  stopovers?: string[];
  service: string;
  ship_date: string;
  estimated_delivery: string;
  weight: number;
  value: number;
  photo_url?: string;
  package_contents?: string;
  delivery_address?: string;
  recipient_name?: string;
  created_at: string;
  updated_at: string;
  // Nouvelles colonnes ajoutées
  order_date?: string;
  actual_delivery_date?: string;
  product_name?: string;
  product_quantity?: number;
  product_price?: number;
  product_photo_url?: string;
  recipient_phone?: string;
  recipient_email?: string;
  recipient_address_line1?: string;
  recipient_address_line2?: string;
  recipient_city?: string;
  recipient_postal_code?: string;
  recipient_country?: string;
  sender_name?: string;
  sender_phone?: string;
  sender_address_line1?: string;
  sender_city?: string;
  sender_country?: string;
  payment_method?: string;
  total_amount?: number;
  currency?: string;
  invoice_url?: string;
  transport_mode?: string;
  is_stopped?: boolean;
  stop_reason?: string;
  current_location?: string;
  notes?: string;
  carrier?: string;
  label?: string;
}
